import React, { useState, useEffect, } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import * as actions from "./_redux/ComponentsActions";
import * as UIHelpers from "./UIHelpers";
import DropdownReactSelect from "./DropdownReactSelect";
import { Select2 } from "select2-react-component";


export default function CountryListDropdown(props) {

  const dispatch = useDispatch();

  const { currentState } = useSelector(
    (state) => ({ currentState: state.components }),
    shallowEqual
  );

  const { countriesList } = currentState;

  const [countriesDropdownFilterData, setCountriesDropdownFilterData] = useState([]);

  useEffect(() => {
    dispatch(actions.fetchCountryList());
  }, []);

  useEffect(() => {
    console.log("countriesList", countriesList);
    if (countriesList && countriesList.data) {
      setCountriesDropdownFilterData(UIHelpers.gameListSearchableDropdownFilterDataFormat(countriesList.data));
    }
  }, [countriesList]);

  return (
    <div className={`d-flex flex-column w-100 ${props?.className ? props?.className : ''}`}>
      {props?.label !== undefined && props?.label !== null && <label>{props?.label} </label>}
      <DropdownReactSelect
        placeholder={'Select Country...'}
        name={'country'}

        isMulti={props.isMulti === undefined ? true : props.isMulti}
        isClearable={true}
        isSearchable={true}
        closeMenuOnSelect={true}

        value={props.countrySelectedDropdownFilterData}
        options={countriesDropdownFilterData}

        onChange={props.setCountryListDropdownFilterData}
      />
    </div>
    // <Select2
    //   // className={getFieldCSSClasses(touched[field.name], errors[field.name])}
    //   data={allGamesDropdownFilterData}
    //   // value={fvalue}
    //   isClearable={true}
    //   // update={value => UpdateValue(value)}
    // ></Select2>
  )
}